import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../authentication/state/authentication.service';
import { AuthenticationQuery } from '../../authentication/state/authentication.query';
import { AuthenticationHttpService } from '../../authentication/services/authentication-http.service';
import { LayoutQuery } from '../../layout/state/layout.query';
import { HttpService } from '../../core/http/http.service';
import { RoleConstant } from '../../user/constants/role.constant';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(
    public authenticationService: AuthenticationService,
    public authenticationQuery: AuthenticationQuery,
    public authenticationHttpService: AuthenticationHttpService,
    public layoutQuery: LayoutQuery,
    private http: HttpService
  ) { }

  downloadFile({ fileName, fileUrl }: { fileName: string; fileUrl: string; }) {
    this.http.getBlob(fileUrl, 'blob' as 'blob')
      .subscribe((res) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(res.body);
        a.download = fileName;
        a.click();
      });
  }
  thousands_separators(num: number) {
    const num_parts = num.toString().split('.');
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return num_parts.join('.');
  }
  public get CanViewDashboard(): boolean {
    if (this.authenticationService.roles) {
      return this.authenticationService.roles.includes(
        RoleConstant.sysAdmin
      ) || this.authenticationService.roles.includes(
        RoleConstant.srSiteInspector
      );
    }

    return false;
  }
}
